  <div [ngClass]="innerClass" class="position-relative">
  <!-- <label *ngIf="label">{{label}}</label> -->
  <mat-label *ngIf="showLabel && label" [ngClass]="inError ? 'required' : ''"
    >{{ label }}
    <span *ngIf="required" class="required">*</span>
  </mat-label>
  <div
    class="form-group"
    *ngIf="parentForm; else noForm"
    [formGroup]="parentForm"
    [ngClass]="inputClass"
  >
    <!--  In FormGroup with FormGroupName-->
    <div
      [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
      *ngIf="
        parentGroupName &&
        type !== 'password' &&
        type !== 'textarea' &&
        type != 'autocomplete' &&
        !arrayName
      "
      [formGroupName]="parentGroupName"
    >
      <input
        [disabled]="isDisabled"
        matInput
        [ngClass]="inError ? 'border-error' : ''"
        *ngIf="controlName"
        [type]="type"
        [max]="max"
        class="form-control"
          [formControlName]="controlName"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      />

      <svg-icon
        class="inner-icon"
        [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
        *ngIf="sideIcon"
        (click)="handleIconClick.emit()"
        svgClass="placeholder-icon"
        [src]="sideIcon"
      >
      </svg-icon>
      <div class="invalid-feedback" *ngIf="inError && errorMessage">
        {{ errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>

    <!--  In FormGroup with FormGroupName & ArrayName-->
    <div [formArrayName]="arrayName" *ngIf="arrayName">
      <div
        [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
        *ngIf="
          type !== 'password' && type !== 'textarea' && type != 'autocomplete'
        "
        [formGroupName]="parentGroupName"
      >
        <input
          [disabled]="isDisabled"
          matInput
          [ngClass]="inError ? 'border-error' : ''"
          *ngIf="controlName"
          [type]="type"
          [max]="max"
          class="form-control"
          [formControlName]="controlName"
          [placeholder]="placeholder"
          (input)="onInput($event)"
        />

        <svg-icon
          class="inner-icon"
          [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
          *ngIf="sideIcon"
          (click)="handleIconClick.emit()"
          svgClass="placeholder-icon"
          [src]="sideIcon"
        >
        </svg-icon>
        <div class="invalid-feedback" *ngIf="inError && errorMessage">
          {{ errorMessage }}
        </div>
        <div class="text-secondary helper" *ngIf="helper">
          {{ helper }}
        </div>
      </div>
    </div>

    <div
      [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
      *ngIf="parentGroupName && type == 'autocomplete'"
      [formGroupName]="parentGroupName"
    >
      <input
        [disabled]="isDisabled"
        matInput
        value="{{ value }}"
        [ngClass]="inError ? 'border-error' : ''"
        *ngIf="controlName"
        [matAutocomplete]="auto"
        [type]="type"
        [max]="max"
        class="form-control"
        [formControlName]="controlName"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option?.value">{{ option?.label }}</mat-option>
        }
      </mat-autocomplete>
      <svg-icon
        class="inner-icon"
        [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
        *ngIf="sideIcon"
        (click)="handleIconClick.emit()"
        svgClass="placeholder-icon"
        [src]="sideIcon"
      ></svg-icon>
      <div class="invalid-feedback" *ngIf="inError && errorMessage">
        {{ errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
    <!--  In FormGroup Without FormGroupName-->
    <div
      *ngIf="
        !parentGroupName &&
        !arrayName &&
        type !== 'password' &&
        type !== 'textarea' &&
        type != 'autocomplete'
      "
      [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
    >
      <input
        [disabled]="isDisabled"
        matInput
        *ngIf="controlName"
        [ngClass]="inError ? 'border-error' : ''"
        [max]="max"
        [type]="type"
        [attr.inputmode]="inputmode || null"
        class="form-control"
        [formControlName]="controlName"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      />
      <svg-icon
        class="inner-icon"
        [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
        *ngIf="sideIcon"
        (click)="handleIconClick.emit()"
        svgClass="placeholder-icon"
        [src]="sideIcon"
      ></svg-icon>
      <div class="invalid-feedback" *ngIf="inError && errorMessage">
        {{ errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
    <div
      *ngIf="!parentGroupName && type == 'autocomplete'"
      [ngClass]="inError ? 'border-error' : ''"
      [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
    >
      <input
        [disabled]="isDisabled"
        matInput
        value="{{ value }}"
        *ngIf="controlName"
        [matAutocomplete]="auto"
        [max]="max"
        [type]="type"
        class="form-control"
        [formControlName]="controlName"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option?.value">{{ option?.label }}</mat-option>
        }
      </mat-autocomplete>
      <svg-icon
        class="inner-icon"
        [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
        *ngIf="sideIcon"
        (click)="handleIconClick.emit()"
        svgClass="placeholder-icon"
        [src]="sideIcon"
      ></svg-icon>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>

    <!--  textArea  -->
    <div
      *ngIf="!parentGroupName && type !== 'password' && type == 'textarea'"
      class="my-3"
      [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
    >
      <textarea
        matInput
        *ngIf="controlName"
        [type]="type"
        class="form-control"
        rows="4"
        [formControlName]="controlName"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      >
      </textarea>
      <div class="suffix text-secondary fs-11 d-flex justify-content-end"

           *ngIf="max">{{ parentForm.get(controlName)?.value?.length }}/{{max}} </div>
      <svg-icon
        class="inner-icon"
        [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
        *ngIf="sideIcon"
        (click)="handleIconClick.emit()"
        svgClass="placeholder-icon"
        [src]="sideIcon"
      ></svg-icon>
      <div class="invalid-feedback" *ngIf="inError">
        {{ errorMessage && errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
  </div>

  <!--  In FormGroup with FormGroupName-->
  <div
    *ngIf="
      control &&
      type !== 'password' &&
      type !== 'textarea' &&
      type != 'autocomplete' &&
      parentGroupName
    "
    [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
    [formGroupName]="parentGroupName"
    [ngClass]="inputClass"
  >
    <input
      [disabled]="isDisabled"
      matInput
      [type]="type"
      class="form-control"
      [max]="max"
      [formControl]="control"
      [placeholder]="placeholder"
      #inputA
      (input)="onInput($event)"
    />
    <svg-icon
      class="inner-icon"
      [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
      *ngIf="sideIcon"
      (click)="handleIconClick.emit(inputA.value)"
      svgClass="placeholder-icon"
      [src]="sideIcon"
    ></svg-icon>
    <!--  (click)="handleIconClick.emit(true)"-->
    <div class="invalid-feedback" *ngIf="control.invalid && control.touched">
      {{ errorMessage && errorMessage }}
    </div>
    <div class="text-secondary helper" *ngIf="helper">
      {{ helper }}
    </div>
  </div>

  <!--  In FormGroup Without FormGroupName-->
  <div
    *ngIf="
      control &&
      type !== 'password' &&
      type !== 'textarea' &&
      type != 'autocomplete'
    "
    [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'"
    [ngClass]="inputClass"
  >
    <input
      [disabled]="isDisabled"
      matInput
      [type]="type"
      class="form-control"
      [max]="max"
      [formControl]="control"
      [placeholder]="placeholder"
      #inputA
      (input)="onInput($event)"
    />
    <svg-icon
      class="inner-icon"
      [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
      *ngIf="sideIcon"
      (click)="handleIconClick.emit(inputA.value)"
      svgClass="placeholder-icon"
      [src]="sideIcon"
    ></svg-icon>
    <!--  (click)="handleIconClick.emit(true)"-->
    <div class="invalid-feedback" *ngIf="control.invalid && control.touched">
      {{ errorMessage && errorMessage }}
    </div>
    <div class="text-secondary helper" *ngIf="helper">
      {{ helper }}
    </div>
  </div>
  <!-- password input -->
  <div class="form-group" *ngIf="type == 'password'" [formGroup]="parentForm" [ngClass]="inputClass">
    <div class="inner-add-on right-add-on">
      <input
        [disabled]="isDisabled"
        [type]="showPassword ? 'text' : 'password'"
        [formControlName]="controlName"
        class="form-control"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      />
      <!-- <svg-icon class="inner-icon" svgClass="placeholder-icon" src="assets/icons/lock-alt.svg"></svg-icon> -->
      <svg-icon
        class="inner-icon right"
        svgClass="placeholder-icon"
        src="assets/icons/{{ !showPassword ? 'eye-icon' : 'eye-crossed' }}.svg"
        (click)="showPassword = !showPassword"
      ></svg-icon>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
  </div>

  <!--  Without FormGroup Assel-->
  <ng-template #noForm>
    <div
      class="form-group"
      [ngClass]="inputClass"
      *ngIf="
        !control &&
        type !== 'password' &&
        type !== 'textarea' &&
        type != 'autocomplete'
      "
    >
      <div [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'" [ngClass]="inputClass">
        <input
          [disabled]="isDisabled"
          matInput
          [type]="type"
          [max]="max"
          class="form-control"
          [placeholder]="placeholder"
          [value]="value"
          #input
          (input)="onInput($event)"
        />
        <svg-icon
          class="inner-icon"
          [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
          *ngIf="sideIcon"
          (click)="handleIconClick.emit(input.value)"
          svgClass="placeholder-icon"
          [src]="sideIcon"
        ></svg-icon>
        <div *ngIf="showLabel && errorMessage" class="invalid-feedback">
          {{ errorMessage }}
        </div>
        <div class="text-secondary helper" *ngIf="helper">
          {{ helper }}
        </div>
      </div>
    </div>
    <div
      class="form-group"
      [ngClass]="inputClass"
      *ngIf="!control && type == 'autocomplete'"
    >
      <div [ngClass]="sideIcon && 'inner-add-on ' + positionIcon + '-add-on'">
        <input
          [disabled]="isDisabled"
          matInput
          value="{{ value }}"
          [type]="type"
          [matAutocomplete]="auto"
          [max]="max"
          class="form-control"
          [placeholder]="placeholder"
          [value]="value"
          #input
          (input)="onInput($event)"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option?.value">{{ option?.label }}</mat-option>
          }
        </mat-autocomplete>
        <svg-icon
          class="inner-icon"
          [ngClass]="handleIconClick ? 'cursor-pointer' : ''"
          *ngIf="sideIcon"
          (click)="handleIconClick.emit(input.value)"
          svgClass="placeholder-icon"
          [src]="sideIcon"
        ></svg-icon>
      </div>
      <div *ngIf="showLabel && errorMessage" class="invalid-feedback">
        {{ errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
  </ng-template>

  <span
    class="text-neutral-dark-grey fs-16 fw-3 placeholder-number"
    *ngIf="(type == 'number' || type == 'text') && currency"
    >{{ currency }}</span
  >
</div>
